import React, { useState } from 'react'
import { Table } from 'reactstrap'

// Import Icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import Attendees from './Attendees';

const RegistrationTable = props => {
    // Defining props as constants
    const registrations = props.registrations
    const setUpdateRegistration = props.setUpdateRegistration
    const cancelRegistration = props.cancelRegistration
    const setRegistration = props.setRegistration

    const [modal, setModal] = useState(false)
    const [guests, setGuests] = useState([])
    const [registrant, setRegistrant] = useState(null)

    const openAttendees = (name, validId, dob, guests) => {
        setModal(!modal)
        setRegistrant({ name, validId, dob })
        setGuests(guests ? guests : [])
    }

    return (
        <>
            <Attendees
                modal={modal}
                toggle={openAttendees}
                registrant={registrant}
                guests={guests}
            />
            <Table className='table'>
                <thead>
                    <tr>
                        <th style={{ width: "13.5%" }} className='rowAlign'>Registered Email</th>
                        <th style={{ width: "13.5%" }} className='rowAlign'>Name</th>
                        <th style={{ width: "13.5%" }} className='rowAlign'>ID</th>
                        <th style={{ width: "13.5%" }} className='rowAlign'>Phone Number</th>
                        <th style={{ width: "13.5%" }} className='rowAlign'>Date</th>
                        <th style={{ width: "13.5%" }} className='rowAlign'>Attendees</th>
                        <th style={{ width: "13.5%" }} className='rowAlign'>Status</th>
                        <th style={{ width: "5.5%" }} className='rowAlign'>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {registrations.map((registration) => {
                        const { _id, sessionId, email, name, status, phoneNumber, validId, dob, guests } = registration
                        return (
                            <tr key={_id}>
                                <td className='rowAlign'>{email}</td>
                                <td className='rowAlign'>{name}</td>
                                <td className='rowAlign'>{validId}</td>
                                <td className='rowAlign'>{phoneNumber}</td>
                                <td className='rowAlign'>{sessionId?.date && sessionId?.date.substr(0, 10)}</td>
                                <td className='rowAlign'><button type="button" className="btn btn-link p-0" onClick={() => openAttendees(name, validId, dob, guests)}>{guests.length + 1}</button></td>
                                <td className='rowAlign'>{status}</td>
                                <td className='rowAlign'>
                                    <center>
                                        <FontAwesomeIcon
                                            color='blue'
                                            className='cursor'
                                            icon={faEdit}
                                            onClick={() => {
                                                setRegistration(registration)
                                                setUpdateRegistration(true)
                                            }}
                                        />
                                        <FontAwesomeIcon
                                            color='red'
                                            className='cursor'
                                            style={{ marginLeft: '6px' }}
                                            icon={faTrash}
                                            onClick={() => cancelRegistration(_id)}
                                        />
                                    </center>
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </Table>
        </>
    )
}

export default RegistrationTable